import openOrUpdatePage from './openOrUpdatePage';

export default openOrUpdatePage.openOrUpdatePage;
